import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import TestFeedbackFormFonts from './TestFeedbackFormFont'
import TestFeedbackFormStyle from './TestFeedbackFormStyle'
import type { TestFeedbackFormBrandType, TestFeedbackBrandForms } from './testFeedbackTypes'

const FORM_MAP: TestFeedbackBrandForms = {
  [BrandFormEnum.STYLE]: TestFeedbackFormStyle,
  ...TestFeedbackFormFonts,
}

const TestFeedbackFormBrand: TestFeedbackFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(TestFeedbackFormBrand) as typeof TestFeedbackFormBrand
